module.exports = __webpack_public_path__ + "images/application/templates/overlay-c4a65053.png";